import { render, staticRenderFns } from "./aboutNews.vue?vue&type=template&id=10997b11&scoped=true&"
import script from "./aboutNews.vue?vue&type=script&lang=js&"
export * from "./aboutNews.vue?vue&type=script&lang=js&"
import style0 from "./aboutNews.vue?vue&type=style&index=0&id=10997b11&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10997b11",
  null
  
)

export default component.exports